<style lang="scss" scoped>
.container {
  // height: 760px;
  border: 1px solid #dcdfe6;
  background: #fff;
  margin-bottom: 10px;
  min-height: 575px;
}
.shaixuan {
  height: 45px;
  background: #606266;
  width: 100%;
  color: #fff;
  line-height: 45px;
  display: flex;
  > div:nth-child(1) {
    width: 80px;
    height: 100%;
    background: #17cfb8;
    text-align: center;
  }
  > div:nth-child(2) {
    flex: 1;
    height: 100%;
    justify-content: space-around;
    display: flex;
    margin-left: 35px;
    margin-right: 60px;
  }
}
.wrap {
  padding: 20px 24px;
  box-sizing: border-box;
  > div {
    float: left;
    border: 1px solid #dcdfe6;
    width: 154px;
    height: 36px;
    box-sizing: border-box;
    line-height: 34px;
    margin-right: 30px;
    margin-bottom: 20px;
  }
  .add {
    background: #173bcf;
    color: #fff;
    text-align: center;
  }
  .tag {
    padding: 0 15px;
    user-select: none;

    .name {
      width: 84px;
    }
    .count {
      color: #0091ff;
    }
    .del {
      cursor: pointer;
    }
  }
}
.select {
  color: #17cfb8;
}
</style>

<template>
  <div>
    <AlertTips />
    <div class="container clearfix">
      <div class="shaixuan">
        <div class="fl pointer" @click="all">全部</div>
        <div class="fr">
          <span
            class="pointer"
            v-for="(i,index) in letter"
            :key="i"
            :class="{select:select == index}"
            @click="changeLetter(i,index)"
          >{{i}}</span>
        </div>
      </div>
      <div class="wrap">
        <div class="add pointer" @click="add">
          <i class="el-icon-circle-plus-outline"></i>
          新建标签
        </div>
        <div
          v-for="item in tagList"
          :key="item.customTagId"
          class="tag pointer"
          :class="{
            'cantdel': item.followers > 0
          }"
          @click="getClickType(item)"
        >
          <span class="name fl line1">{{item.name}}</span>
          <span
            class="count fr"
            v-if="item.followers"
          >{{item.followers > 999 ? '999+' : item.followers}}</span>
          <span v-else class="del fr" @click.stop="del(item.customTagId)">
            <i class="el-icon-delete"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertTips from '@/components/alertTips';
export default {
  components: {
    AlertTips,
  },
  computed: {},
  props: ['id'],
  data() {
    return {
      clickNum: 0,
      chooseItem: null,
      select: -1,
      show: false,
      name: '',
      title: 0,
      allList: [],
      tagList: [],
      tagNameList: [],
      customId: '',
      timer: null,
      letter: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
    };
  },
  watch: {
    tagList(val) {
      val.forEach(item => {
        this.tagNameList.push(item.name);
      });
    },
    clickNum(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (val === 1) {
          this.goList(this.chooseItem);
        } else if (val > 1) {
          this.edit(this.chooseItem.name, this.chooseItem.customTagId);
        }
        this.clickNum = 0;
      }, 300);
    },
  },
  methods: {
    all() {
      this.select = -1;
      this.tagList = [];
      this.allList.forEach(item => {
        this.tagList.push(...item.customTags);
      });
    },
    changeLetter(i, index) {
      this.select = index;
      let arr = this.allList.filter(item => {
        return item.prifex == i;
      });
      this.tagList = [];
      if (arr.length) {
        this.tagList = arr[0].customTags;
      }
    },
    async edit(name, id) {
      let res = await this.$prompt('标签名', '编辑标签', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: name,
        inputValidator: v => {
          if (!v) {
            return '标签名不能为空';
          }
        },
      });
      this.name = res.value;
      this.title = 0;
      this.customId = id;
      this.submit();
    },
    async add() {
      clearTimeout(this.timer);
      let res = await this.$prompt('标签名', '新建标签', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: v => {
          if (!v) {
            return '标签名不能为空';
          }
          if (v.length >= 30) {
            return '标签名不能超过30个字节';
          }
        },
      });
      this.name = res.value;
      this.title = 1;
      this.submit();
    },
    async submit() {
      if (!this.name) {
        this.$message.error('请填写标签名字');
        return;
      }
      if (this.tagNameList.includes(this.name)) {
        this.$message.error(`标签${this.name}已存在，请勿重复添加`);
        return;
      }
      let url = `/api/${this.id}/custom-tag`;
      url = this.title ? url : `${url}/${this.customId}`;
      let res = await this.$http[this.title ? 'post' : 'put'](url, {
        name: this.name,
      });
      if (res) {
        this.$message({
          message: `${this.title ? '添加' : '修改'}成功`,
          type: 'success',
        });
        await this.getData();
        if (this.title) {
          this.fmtList(this.name);
        }
      }
      this.show = false;
    },

    fmtList(val) {
      let list = this.tagList,
        ret = [];
      list.map(item => {
        if (item.name == val) {
          ret.unshift(item);
        } else {
          ret.push(item);
        }
      });
      this.tagList = ret;
    },

    async del(id) {
      let res = await this.$confirm('是否删除此标签?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      if (res) {
        await this.$http.delete(`/api/${this.id}/custom-tag/${id}`);
        await this.getData();
        this.$message({
          message: `删除成功`,
          type: 'success',
        });
      }
    },
    async getData() {
      let res = await this.$http.get(`/api/${this.id}/custom-tags`);
      this.tagList = [];
      this.allList = res;
      res.forEach(item => {
        this.tagList.push(...item.customTags);
      });
    },

    goList(item) {
      this.$router.push({
        path: `/third/${this.id}/tag/list`,
        query: {
          tagid: item.customTagId,
        },
      });
    },
    getClickType(item) {
      this.clickNum++;
      this.chooseItem = item;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
